module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_yee_sm-2ad680aa061610b368818e718a110fc3.png";